import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Box } from '@mui/system';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { CheckMarkIcon } from '../../components/icons/icons';
import { useRef, useState } from 'react';

const CustomFormControl = ({ fieldProps, errorMsg }) => {
    const inputRef = useRef();
    const [isPassVisible, setIsPassVisible] = useState(false);
    const [fieldType, setFieldType] = useState(fieldProps?.type);

    const validateEmail = () => {
        const emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
        return emailRegex.test(inputRef.current.value);
    };
    const confPassField = () => {
        setIsPassVisible(!isPassVisible);
        let type = isPassVisible ? 'password' : 'text';
        setFieldType(type);
    };
    const getIcon = () => {
        if (inputRef.current.name === 'email') {
            return validateEmail() ? <CheckMarkIcon /> : null;
        }
        if (inputRef.current.name.toLowerCase().endsWith('password')) {
            return (
                <IconButton  onClick={() => confPassField()}  sx={{mr:'-0.6rem'}}>
                    {isPassVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            );
        }
        return null;
    };

    return (
        <Box>
            <TextField
                sx={{ bgcolor: '#fff' }}
                variant='outlined'
                inputRef={inputRef}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end' >
                            {' '}
                            {inputRef.current ? getIcon() : ' '}
                        </InputAdornment>
                    ),
                }}
                {...fieldProps}
                error={errorMsg ? true : false}
                type={fieldType}
                fullWidth
            />
        </Box>
    );
};

export default CustomFormControl;
